module.exports = __webpack_public_path__ + "static/media/twitter-icon.c4a0c1f7.svg";